import React from 'react';
import {Button, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from './img/Explore with line.webp'
import img2 from './img/Curated with line.webp'
import img3 from './img/Partnering with line.webp'
import img4 from './img/Connecting with line.webp'
import img5 from './img/Playlists with line.webp'
import {ReactComponent as HeadLogo} from './img/Curated Logo.svg'
import {TitleText} from "./text";
import './style.scss'

const CuratedCollections = (props) => {
    return (
        <Layout>
            <Content>
                <Row justify={"center"} style={{
                    margin: '2rem 0 0 0'
                }}>
                    <HeadLogo/>
                </Row>
                <Row justify={"center"} style={{
                    margin: '0 0 2rem 0'
                }}>
                    {TitleText.map((txt, idx) => {
                        return (
                            idx === 0 ? <p className={'curated-txt'} key={idx}
                                           style={{margin: '-5rem 0 0 0'}}
                                >
                                    {txt}
                                </p> :
                                <p className={'curated-txt'}
                                   key={idx}
                                   style={{margin: '-3rem 0 0 0'}}
                                >
                                    {txt}
                                </p>
                        )
                    })}
                </Row>
                <Row justify={"center"}>
                    <Button className={'dsa-btn'}>
                        Discover Art
                    </Button>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img1} alt={img1} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Explore Art, Get Inspired
                            </p>
                            <p className={'curated-p'}>
                                Explore the vast Vieunite Art Library and discover artwork or playlists that suit your
                                business needs. From classic art pieces to contemporary photography, the Vieunite Pro
                                Collection offers a diverse range of work for your display.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container" style={{width:'100%'}}>
                        <img src={img2} alt={img2} className="curated-overlay-image" style={{width:'100%'}}/>
                        <div className="curated-text-overlay curated-overlay-left">
                            <p className={'curated-h1'}>
                                Curated Artwork
                            </p>
                            <p className={'curated-p'}>
                                Contains over thousands high-quality and carefully selected artwork, encompassing both
                                contemporary and classic art. You can browse the artwork based on your specific business
                                industry, which includes hospitality, healthcare, education, and more.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img3} alt={img3} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Partnering With Artists
                            </p>
                            <p className={'curated-p'}>
                                Featuring over 200 artists, our collection includes works by both young contemporary
                                artists and renowned, established artists.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container" style={{width:'100%'}}>
                        <img src={img4} alt={img4} className="curated-overlay-image" style={{width:'100%'}}/>
                        <div className="curated-text-overlay curated-overlay-left">
                            <p className={'curated-h1'} style={{color:"white"}}>
                                Connecting You to Galleries
                            </p>
                            <p className={'curated-p'} style={{color:"white"}}>
                                We actively collaborate with renowned and emerging art museums and galleries worldwide,
                                allowing you to explore a thoughtfully curated selection of artwork from the collections
                                of major museums and art galleries on our platform.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img5} alt={img5} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Playlists
                            </p>
                            <p className={'curated-p'}>
                                Opt for our Standard subscription to gain unrestricted access to all the playlists. Or
                                upgrade to our Premium option to get a personalised and exclusive playlist crafted by
                                our team, to express your style and business values. Enjoy the peace of mind that comes
                                with effortless content publishing.
                            </p>
                        </div>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default CuratedCollections;
